const CURRENCY_SYMBOL_LOCAL_MAP: { [key: string]: string } = {
    us: '$', // 前面
    ca: '$', // 前
    uk: '£', // 前
    eu: '€', // 前
    de: '€', // 后
    fr: '€', // 后
    it: '€', // 后
    es: '€', // 后
    cis: '₽', // 后
    jp: '¥', // 前
    cn: '¥', // 前
    kr: '₩', // 前
    sa: 'د.إ', // 前
    za: 'R', // 前
    au: '$', // 前
    tw: 'NT$', // 前
    hk: 'HK$', //前
    br: 'R$', // 前
    mx: 'MXN ', // 前
    ph: '₱', // 前
};

// 货币符号位置在后的站点
const CURRENCY_SYMBOL_AFTER_SITES: string[] = ['de', 'fr', 'it', 'es', 'cis'];
// 千分位分隔符为英文句号的站点
const THOUSANDS_SEPARATOR_PERIOD_SITES: string[] = ['eu', 'it', 'es'];
// 千分位分隔符为空格的站点
const THOUSANDS_SEPARATOR_SPACE_SITES: string[] = ['de', 'fr'];
// 小数点分割符为逗号的站点
const DECIMAL_SEPARATOR_COMMA_SITES: string[] = ['eu', 'de', 'fr', 'it', 'es'];
// 货币符号与货币之间有空格的站点
const HAS_SPACE_BETWEEN_SITES: string[] = ['de', 'fr', 'it', 'za', 'mx', 'br'];

const _getCurrencySymbol = (locale: string) => {
    return CURRENCY_SYMBOL_LOCAL_MAP[locale] || CURRENCY_SYMBOL_LOCAL_MAP.us;
};

const _getThousandsSeparator = (locale: string) => {
    if (THOUSANDS_SEPARATOR_PERIOD_SITES.includes(locale)) {
        return '.';
    }
    if (THOUSANDS_SEPARATOR_SPACE_SITES.includes(locale)) {
        return '\u202F';
    }
    return ',';
};

const _getDecimalSeparator = (locale: string) => {
    if (DECIMAL_SEPARATOR_COMMA_SITES.includes(locale)) {
        return ',';
    }
    return '.';
};

const _getHasSpaceBetween = (locale: string) => {
    return HAS_SPACE_BETWEEN_SITES.includes(locale) ? ' ' : '';
};

const FormatCurrencyLocal = (value: number, locale: string, isShoppingCart?: boolean) => {
    if (!value && value !== 0) return value;
    let strValue: string = value.toString();
    const currencySymbol = _getCurrencySymbol(locale);
    const thousandsSeparator = _getThousandsSeparator(locale);
    const decimalSeparator = _getDecimalSeparator(locale);
    const hasSpaceBetween = _getHasSpaceBetween(locale);

    if (DECIMAL_SEPARATOR_COMMA_SITES.includes(locale)) {
        strValue = strValue.replace('.', decimalSeparator);
    }
    const reg = /(\d)(?=(\d{3})+$)/g;
    strValue = strValue.replace(reg, `$1${thousandsSeparator}`);
    strValue = CURRENCY_SYMBOL_AFTER_SITES.includes(locale)
        ? `${strValue}${hasSpaceBetween}${currencySymbol}`
        : `${currencySymbol}${hasSpaceBetween}${strValue}`;
    // 购物车中的整数需要 加小数点后两位， 如果strValue已经是带了两位小数00时，如12.00，不需要加
    if (isShoppingCart && (value | 0) === value && !strValue.includes(decimalSeparator)) {
        strValue = `${strValue}${decimalSeparator}00`;
    }
    return strValue;
};

export default FormatCurrencyLocal;
